import axios from "axios";
import getVocabolario from "@/utilities/utilityCercaVocabolario";
const pathResourceLoginWso2 = "https://auth.ak12srl.it/token";
export default {
  methods: {
    loginWso2: function() {
      try {
        const params = new URLSearchParams();
        params.append("grant_type", "client_credentials");
        axios
          .post(pathResourceLoginWso2, params, {
            auth: {
              username: "NUy4PkI5xk3rZjhyf1Rcc6Jep_oa",
              password: "VyvhfPx3A1u9v49Z6fF8OWbJ5vUa",
            },
            headers: {
              "Content-type": "application/x-www-form-urlencoded",
              "Access-Control-Allow-Origin": "*",
            },
          })
          .then((response) => {
            sessionStorage.setItem("tokenWSO2", response.data.access_token);
            return response.data.access_token;
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (ex) {
        console.log(ex);
      }
    },
    errorAuthWso2: function(vueInstance, responseWso2) {
      if (responseWso2.status === 401) {

          let msg = getVocabolario("sessioneScaduta")
          if(!msg)
              msg = "Effettua nuovamente l'accesso."
        vueInstance.$bvModal.msgBoxOk(msg, {
          title: "Sessione scaduta",
          size: "sm",
          okVariant: "outline-danger",
          headerClass: "vv-msg-header-danger",
          footerClass: "p-2 border-top-0",
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
        })
        .catch((err) => {
          console.log(err);
        });
        vueInstance.$router.replace("/").catch((err) => {
          err;
        });
      }
      else {
        vueInstance.$bvModal.msgBoxOk("Si è verificato un errore.", {
          title: "Errore",
          size: "sm",
          okVariant: "outline-danger",
          headerClass: "vv-msg-header-danger",
          footerClass: "p-2 border-top-0",
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
        })
        .catch((err) => {
          console.log(err);
        });
      }
    }
  }
}
